import { graphql } from 'GQL/gql';

export const GET_ALL_ASSIGNED_SKILL_VALIDATIONS = graphql(`
  query GET_ALL_ASSIGNED_SKILL_VALIDATIONS(
    $policiesPreset: PoliciesPresetInput
    $userId: ID
    $suggestedAction: [UserValidateSkillSuggestedActionFilterEnum] = [empty, add]
  ) {
    userValidateSkillsV2(suggestedAction: $suggestedAction, userId: $userId) {
      b2b {
        ...skillToValidateFragment
      }
      managerAssessment {
        ...skillToValidateFragment
      }
      personalDevelopmentMeasure {
        ...skillToValidateFragment
      }
      selfAdded {
        ...skillToValidateFragment
      }
    }
  }
`);
